/**
 * Cumprimento da tela Início (aprovado em 02/11/2026, protótipo "Início com mais vida"):
 * "Bom dia / Boa tarde / Boa noite, Fulano!" conforme a hora do aparelho, e a data por extenso.
 */

/** Bom dia das 5h às 11h59; boa tarde das 12h às 17h59; boa noite das 18h às 4h59. */
export function saudacaoDoDia(agora: Date = new Date()): string {
  const hora = agora.getHours();
  if (hora >= 5 && hora < 12) return "Bom dia";
  if (hora >= 12 && hora < 18) return "Boa tarde";
  return "Boa noite";
}

/** "segunda-feira, 2 de novembro" (sem ano; minúsculas, como o texto de apoio da tela). */
export function dataPorExtenso(agora: Date = new Date()): string {
  return agora.toLocaleDateString("pt-BR", { weekday: "long", day: "numeric", month: "long" });
}
